import { render, staticRenderFns } from "./ExchangeSuccessModal.vue?vue&type=template&id=4beaf11c&scoped=true"
import script from "./ExchangeSuccessModal.vue?vue&type=script&lang=js"
export * from "./ExchangeSuccessModal.vue?vue&type=script&lang=js"
import style0 from "./ExchangeSuccessModal.vue?vue&type=style&index=0&id=4beaf11c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4beaf11c",
  null
  
)

export default component.exports